import { UserService } from '../../providers'

const UserModule = {
  namespaced: true,
  state: {
    isSelectBasicId: false,
    userProfile: {}
  },
  mutations: {
    SET_USER_PROFILE (state, data) {
      state.userProfile = data
    },
    SET_USER_PROFILE_OWN_LINE_OFFICIAL_ACCOUNTS (state, data = []) {
      state.userProfile.ownLineOfficialAccounts = data
    },
    SET_SELECT_BASIC_ID (state, data) {
      state.isSelectBasicId = data
    }
  },
  actions: {
    async fetchProfile ({ commit }, params) {
      const result = await UserService.fetchProfile(params)

      commit('SET_USER_PROFILE', result)
      return result
    },
    createLineOfficialAccounts (context, params) {
      return UserService.createLineOfficialAccounts(params)
    },
    async updateBatchHideLineOfficialAccount ({ state, commit }, params) {
      const result = await UserService.updateBatchHideLineOfficialAccount(params)
      const { ownLineOfficialAccounts } = state.userProfile

      const userProfile = {
        ...state.userProfile,
        ownLineOfficialAccounts: ownLineOfficialAccounts.map((lineOa) => ({
          ...lineOa,
          lineOfficialAccount: {
            ...lineOa.lineOfficialAccount,
            hide: params.lineOaId.includes(lineOa.lineOfficialAccount.id)
              ? params.hide
              : lineOa.lineOfficialAccount.hide
          }
        }))
      }

      commit('SET_USER_PROFILE', userProfile)
      return result
    },
    setSelectBasicId({ commit }, params) {
      commit('SET_SELECT_BASIC_ID', params)
    }
  },
  getters: {
    isSelectBasicId (state) {
      return state.isSelectBasicId
    },
    isUserProfileEmpty (state) {
      return Object.keys(state.userProfile).length === 0
    },
    ownLineOfficialAccounts (state) {
      return state.userProfile.ownLineOfficialAccounts || []
    },
    hasLineOfficialAccount (state) {
      return state.userProfile.ownLineOfficialAccounts
        && state.userProfile.ownLineOfficialAccounts.length > 0
    },
    activeLineOfficialAccount (state) {
      return state.userProfile.activeLineOfficialAccount || {}
    },
    isActiveLineOfficialAccountEmpty (state) {
      return !state.userProfile.activeLineOfficialAccount
    },
    activeBasicId (state) {
      return state.userProfile.activeLineOfficialAccount
        ? state.userProfile.activeLineOfficialAccount.basicId
        : ''
    },
    mapBasicIds (state) {
      if (!state.userProfile.ownLineOfficialAccounts) {
        return []
      }

      return state.userProfile.ownLineOfficialAccounts.map(
        (item) => item.lineOfficialAccount.basicId
      )
    }
  }
}

export default UserModule
